import * as yup from "yup";

export const UNIQUE_VALUES_COLUMN = [
  {
    title: "value",
    key: "name",
    dataIndex: "name",
  },
  {
    title: "# OF UNIQUES",
    key: "total_count",
    dataIndex: "total_count",
  },
];

export const CREATE_SOURCE_INITIAL_VALUES = {
  referenceSourceName: "",
  referenceSourceDescription: "",
  referenceType: "",
  scope: "",
  drafter: "",
  approver: "",
};

export const CREATE_SOURCE_VALIDATION_SCHEMA = yup.object().shape({
  referenceSourceName: yup
    .string()
    .required("Reference Source Name is a required field."),
  referenceType: yup.object().required("Reference Type is a required field."),
  scope: yup.object().required("Scope is a required field."),
  drafter: yup.object().required("Drafter is a required field."),
  approver: yup.object().required("Approver is a required field."),
});

export const REFERENCE_TYPES = [
  { value: "enterprise", label: "Enterprise" },
  { value: "others", label: "Others" },
];

export const SCOPE_TYPES = [
  { value: "public", label: "Public" },
  { value: "private", label: "Private" },
];
